var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"star-wrap"},[_vm._l((_vm.fullNum),function(i){return _c('div',{key:'full-star' + i,staticClass:"one-star",style:({
      width: _vm.size + 'px',
      height: _vm.size + 'px',
      marginRight: i !== _vm.allStart && _vm.spacing
    })},[_c('fps-icon',{staticClass:"star",attrs:{"type":"star1","size":_vm.size,"color":_vm.color}})],1)}),_vm._v(" "),(_vm.hashalf)?_c('div',{staticClass:"one-star",style:({
      width: _vm.size + 'px',
      height: _vm.size + 'px',
      marginRight: _vm.fullNum !== _vm.allStart - 1 && _vm.spacing
    })},[_c('fps-icon',{staticClass:"star",attrs:{"type":"star1","size":_vm.size,"color":"#EEEEEE"}}),_vm._v(" "),_c('fps-icon',{staticClass:"star",attrs:{"type":"star1-half","size":_vm.size,"color":_vm.color}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.nullNum),function(i){return _c('div',{key:'null-star' + i,staticClass:"one-star",style:({
      width: _vm.size + 'px',
      height: _vm.size + 'px',
      marginRight: _vm.nullNum !== i && _vm.spacing
    })},[_c('fps-icon',{staticClass:"star",attrs:{"type":"star1","size":_vm.size,"color":"#EEEEEE"}})],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }